import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardWrapper, CardHeader, CardSection } from 'foundations-components/transitional/components/Card';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { CreditCardIcon } from 'foundations-assets/icons/components/CreditCardIcon';
import { BankIcon } from 'foundations-assets/icons/components/BankIcon';
import { PAYMENT_METHOD_TYPE } from '../utils/typeAdapters';
import { useIsMobileView } from '../hooks/useWindowSize';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function PaymentMethodsCard({
  paymentMethods = []
}) {
  const isMobileView = useIsMobileView();
  return /*#__PURE__*/_jsxs(CardWrapper, {
    children: [/*#__PURE__*/_jsx(CardHeader, {
      padding: isMobileView ? '700' : undefined,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "paymentMethods.title"
      })
    }), /*#__PURE__*/_jsx(CardSection, {
      padding: isMobileView ? '700' : undefined,
      children: paymentMethods.map(paymentMethod => /*#__PURE__*/_jsx(PaymentMethodTile, {
        paymentMethod: paymentMethod
      }, paymentMethod.objectId))
    })]
  });
}
export function PaymentMethodTile({
  paymentMethod
}) {
  const {
    type,
    last4
  } = paymentMethod.paymentMethodDetails;
  const {
    storedOn,
    isDefault
  } = paymentMethod;
  const isCard = type === PAYMENT_METHOD_TYPE.CARD;
  return /*#__PURE__*/_jsx(Tile, {
    children: /*#__PURE__*/_jsxs(TileSection, {
      paddingInline: "700",
      paddingBlock: "600",
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        justifyContent: "space-between",
        columnGap: "400",
        marginBlockEnd: "300",
        children: [/*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          columnGap: "200",
          children: [isCard ? /*#__PURE__*/_jsx(CreditCardIcon, {}) : /*#__PURE__*/_jsx(BankIcon, {}), /*#__PURE__*/_jsx(Text, {
            typography: "heading-200",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: isCard ? 'paymentMethods.method.card' : 'paymentMethods.method.ach'
            })
          })]
        }), isDefault && /*#__PURE__*/_jsx(Badge, {
          use: "oz",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "paymentMethods.default"
          })
        })]
      }), /*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "paymentMethods.last4",
          options: {
            lastFour: last4
          }
        })
      }), /*#__PURE__*/_jsx(Text, {
        typography: "detail-100",
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "paymentMethods.storedOn",
          options: {
            date: /*#__PURE__*/_jsx(FormattedDateTime, {
              value: storedOn,
              format: "LL"
            })
          }
        })
      })]
    })
  });
}